<form [formGroup]="form" class="flex flex-col">
    <div class="flex flex-wrap w-full xl:grid xl:grid-cols-2 xl:gap-10">
        <div class="flex items-center w-full xl:col-span-1 mb-5">
            <app-form-number-indicator
                [formFieldNumber]="'1'"
            ></app-form-number-indicator>
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Radio Service Code</mat-label>
                <mat-select
                    appSelectTypeahead
                    formControlName="radioServiceCode"
                    required
                >
                    @for (
                        radioServiceCode of radioServiceCodes;
                        track radioServiceCode.value
                    ) {
                        <mat-option [value]="radioServiceCode.value">{{
                            radioServiceCode.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="flex items-center w-full xl:col-span-1 mb-5">
            <app-form-number-indicator
                [formFieldNumber]="'1a'"
            ></app-form-number-indicator>
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Existing Radio Service Code</mat-label>
                <mat-select
                    formControlName="existingRadioServiceCode"
                ></mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="flex flex-wrap w-full xl:grid xl:grid-cols-2 xl:gap-10">
        <div class="flex items-center w-full xl:col-span-1 mb-5">
            <app-form-number-indicator
                [formFieldNumber]="'2'"
            ></app-form-number-indicator>
            <mat-form-field appearance="outline" class="w-full">
                <mat-label>Purpose</mat-label>
                <mat-select formControlName="applicationPurpose" required>
                    @for (
                        applicationPurpose of applicationPurposes;
                        track applicationPurpose.value
                    ) {
                        <mat-option [value]="applicationPurpose.value">{{
                            applicationPurpose.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="flex flex-wrap w-full xl:grid xl:grid-cols-2 xl:gap-10">
        <div class="flex-column-w-col-span-1">
            <div class="flex items-center w-full">
                <app-form-number-indicator
                    [formFieldNumber]="'3a'"
                ></app-form-number-indicator>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label
                        >Demonstration License or Special
                        Temporary...</mat-label
                    >
                    <mat-select formControlName="developmentalOrSta" required>
                        @for (
                            licenseType of licenseTypes;
                            track licenseType.value
                        ) {
                            <mat-option [value]="licenseType.value">{{
                                licenseType.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="flex items-center justify-between w-full pl-16 mt-1">
                <span class="text-xs">{{
                    messages.demonstrationLicense | ellipsis: 55
                }}</span>
                <img
                    [matTooltipPosition]="'right'"
                    matTooltip="{{ messages.demonstrationLicense }}"
                    src="assets/svg/question-tooltip.svg"
                    alt="question mark"
                    class="tool-tip"
                />
            </div>
        </div>

        @if (showEmergencySituation()) {
            <div
                class="flex-row items-start w-full xl:col-span-1 grid grid-cols-12 gap-3 mb-5"
            >
                <div
                    class="flex items-center w-full"
                    [ngClass]="
                        form.controls.emergencySta.value
                            ? 'col-span-8'
                            : 'col-span-12'
                    "
                >
                    <app-form-number-indicator
                        [formFieldNumber]="'3b'"
                    ></app-form-number-indicator>
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Emergency Situation</mat-label>
                        <mat-select formControlName="emergencySta">
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">{{
                                    yesNoOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                @if (form.controls.emergencySta.value) {
                    <div class="flex col-span-4">
                        <app-attachment-required-button class="w-full" />
                    </div>
                }
            </div>
        }
    </div>

    <div class="flex flex-wrap w-full xl:grid xl:grid-cols-2 xl:gap-10">
        <div class="flex-column-w-col-span-1">
            <div class="flex items-center w-full">
                <app-form-number-indicator
                    [formFieldNumber]="'4'"
                ></app-form-number-indicator>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Application File Number</mat-label>
                    <input title="Application File Number" matInput disabled />
                </mat-form-field>
            </div>
            <div class="flex items-center justify-between w-full pl-16 mt-1">
                <span class="text-xs">{{
                    messages.applicationFileNumber | ellipsis: 53
                }}</span>
                <img
                    [matTooltipPosition]="'right'"
                    matTooltip="{{ messages.applicationFileNumber }}"
                    src="assets/svg/question-tooltip.svg"
                    alt="question mark"
                    class="tool-tip"
                />
            </div>
        </div>
    </div>

    <div class="flex flex-wrap w-full xl:grid xl:grid-cols-2 xl:gap-10">
        <div class="flex-column-w-col-span-1">
            <div class="flex items-center w-full">
                <app-form-number-indicator
                    [formFieldNumber]="'5'"
                ></app-form-number-indicator>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Call Sign of Existing FCC License</mat-label>
                    <input
                        formControlName="callSign"
                        title="Call Sign of Existing FCC License"
                        matInput
                    />
                </mat-form-field>
            </div>
            <div class="flex items-center justify-between w-full pl-16 mt-1">
                <span class="text-xs">{{
                    messages.callSignOfExistingFccLicense | ellipsis: 55
                }}</span>
                <img
                    [matTooltipPosition]="'right'"
                    matTooltip="{{ messages.callSignOfExistingFccLicense }}"
                    src="assets/svg/question-tooltip.svg"
                    alt="question mark"
                    class="tool-tip"
                />
            </div>
        </div>
    </div>

    <div class="flex flex-wrap w-full xl:grid xl:grid-cols-2 xl:gap-10">
        <div class="flex-column-w-col-span-1">
            <div class="flex items-center w-full">
                <app-form-number-indicator
                    [formFieldNumber]="'6a'"
                ></app-form-number-indicator>
                <mat-form-field
                    appearance="outline"
                    class="w-full"
                    [color]="
                        form.get('requestedExpirationDate')?.invalid
                            ? 'warn'
                            : 'primary'
                    "
                >
                    <mat-label>Date (MMDD)</mat-label>
                    <input
                        title="Date (MMDD)"
                        matInput
                        formControlName="requestedExpirationDate"
                        placeholder="MMDD"
                        placeHolderCharacter="_"
                        mask="0000"
                    />
                </mat-form-field>
            </div>
            <div class="flex items-center justify-between w-full pl-16 mt-1">
                <span class="text-xs">{{
                    messages.requestedExpirationDate | ellipsis: 55
                }}</span>
                <img
                    [matTooltipPosition]="'right'"
                    matTooltip="{{ messages.requestedExpirationDate }}"
                    src="assets/svg/question-tooltip.svg"
                    alt="question mark"
                    class="tool-tip"
                />
            </div>
        </div>
        <div class="flex-column-w-col-span-1">
            <div class="flex items-center w-full">
                <app-form-number-indicator
                    [formFieldNumber]="'6b'"
                ></app-form-number-indicator>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>License Type</mat-label>
                    <mat-select formControlName="useOfServiceType" required>
                        @for (
                            useOfService of useOfServices;
                            track useOfService.value
                        ) {
                            <mat-option [value]="useOfService.value">{{
                                useOfService.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="flex items-center justify-between w-full pl-16 mt-1">
                <span class="text-xs">{{
                    messages.licenseType | ellipsis: 56
                }}</span>
                <img
                    [matTooltipPosition]="'right'"
                    matTooltip="{{ messages.licenseType }}"
                    src="assets/svg/question-tooltip.svg"
                    alt="question mark"
                    class="tool-tip"
                />
            </div>
        </div>
    </div>

    <div class="flex flex-wrap w-full xl:grid xl:grid-cols-2 xl:gap-10">
        <div class="flex-column-w-col-span-1">
            <div class="flex items-center w-full">
                <app-form-number-indicator
                    [formFieldNumber]="'7'"
                ></app-form-number-indicator>
                <mat-form-field appearance="outline" class="w-full">
                    <mat-label>Application Major</mat-label>
                    <mat-select formControlName="isApplicationMajor">
                        @for (
                            yesNoOption of yesNoOptions;
                            track yesNoOption.value
                        ) {
                            <mat-option [value]="yesNoOption.value">{{
                                yesNoOption.label
                            }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="flex items-center justify-between w-full pl-16 mt-1">
                <span class="text-xs">{{
                    messages.applicationMajor | ellipsis: 54
                }}</span>
                <img
                    [matTooltipPosition]="'right'"
                    matTooltip="{{ messages.applicationMajor }}"
                    src="assets/svg/question-tooltip.svg"
                    alt="question mark"
                    class="tool-tip"
                />
            </div>
        </div>
    </div>

    <div class="flex flex-wrap w-full xl:grid xl:grid-cols-2 xl:gap-10">
        <div
            class="flex-row items-start w-full xl:col-span-1 grid grid-cols-12 gap-3 mb-5"
        >
            <div
                class="flex flex-col items-start w-full"
                [ngClass]="
                    form.controls.hasAttachments.value
                        ? 'col-span-8'
                        : 'col-span-12'
                "
            >
                <div class="flex items-center w-full">
                    <app-form-number-indicator
                        [formFieldNumber]="'8'"
                    ></app-form-number-indicator>
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-label>Attachments</mat-label>
                        <mat-select formControlName="hasAttachments">
                            @for (
                                yesNoOption of yesNoOptions;
                                track yesNoOption.value
                            ) {
                                <mat-option [value]="yesNoOption.value">{{
                                    yesNoOption.label
                                }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div
                    class="flex items-center justify-between w-full pl-16 mt-1"
                >
                    <span class="text-xs">{{
                        messages.attachments | ellipsis: 49
                    }}</span>
                    <img
                        [matTooltipPosition]="'right'"
                        matTooltip="{{ messages.attachments }}"
                        src="assets/svg/question-tooltip.svg"
                        alt="question mark"
                        class="tool-tip"
                    />
                </div>
            </div>
            @if (form.controls.hasAttachments.value) {
                <div class="flex col-span-4">
                    <app-attachment-required-button class="w-full" />
                </div>
            }
        </div>
    </div>
</form>
